import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token if present (fallback to cookie)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("orax_token");
  if (token) {
    config.headers = config.headers || {};
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default api;

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const IMAGES = {
  heroBackground:
    "https://images.pexels.com/photos/9875685/pexels-photo-9875685.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  residential:
    "https://images.unsplash.com/photo-1761158495585-eac721decf1b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxyZXNpZGVudGlhbCUyMHNvbGFyJTIwcGFuZWxzJTIwcm9vZnxlbnwwfHx8fDE3NzY2OTYyMDJ8MA&ixlib=rb-4.1.0&q=85",
  commercial:
    "https://images.unsplash.com/photo-1713544123580-12096cc9eb12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxjb21tZXJjaWFsJTIwc29sYXIlMjBwYW5lbHN8ZW58MHx8fHwxNzc2Njk2MjA3fDA&ixlib=rb-4.1.0&q=85",
  texture:
    "https://images.pexels.com/photos/18306342/pexels-photo-18306342.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  worker:
    "https://images.pexels.com/photos/8853507/pexels-photo-8853507.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  family:
    "https://images.pexels.com/photos/11708063/pexels-photo-11708063.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const CONTACT = {
  phonePrimary: "9422921481",
  phoneSecondary: "9673481286",
  email: "Info@Oraxsolar.com",
  address: "Opp. LIC office, Near Tower Chowk, Umri Road, Akola, Maharashtra",
  whatsapp: "9422921481",
};
